import script from "./PlanFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanFormView.vue?vue&type=script&setup=true&lang=js"

import "./PlanFormView.vue?vue&type=style&index=0&id=5fb95940&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb95940"]])

export default __exports__